"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHANNEL_ICONS = exports.CAMPAIGN_ICONS = exports.AGENT_STATUS_TO_ICON = void 0;
var AGENT_STATUS_TO_ICON_DICTIONARY = {
  ready: 'agent',
  dialog: 'call',
  dialoginit: 'call',
  xfer: 'xfer',
  xferinit: 'xfer',
  xferqueue: 'call',
  callout: 'call',
  notready: 'unavailable-agent',
  wrapup: 'notes',
  problem: 'warning',
  other: 'transfer',
  login: 'agent',
  logout: 'agent',
  ringing: 'call',
  unknown: 'question',
  chatting: 'chat',
  assisted: 'assisted',
  whatsappdialog: ['whatsapp', 'whatsapp-filled'],
  preview: 'preview',
  readypreview: 'readypreview',
  inactive: 'inactive-agent',
  emaildialog: 'mail'
};
var AGENT_STATUS_TO_ICON = new Proxy(AGENT_STATUS_TO_ICON_DICTIONARY, {
  get: function get(object, property) {
    return object.hasOwnProperty(property) ? object[property] : 'question';
  }
});
exports.AGENT_STATUS_TO_ICON = AGENT_STATUS_TO_ICON;
var CAMPAIGN_ICON_DICTIONARY = [{
  id: 1,
  icon: 'meeting'
}, {
  id: 2,
  icon: 'globe'
}, {
  id: 3,
  icon: 'call'
}, {
  id: 4,
  icon: 'swim'
}, {
  id: 5,
  icon: 'anchor'
}, {
  id: 6,
  icon: 'health'
}, {
  id: 7,
  icon: 'plus'
}, {
  id: 8,
  icon: 'trip'
}, {
  id: 9,
  icon: 'star'
}, {
  id: 10,
  icon: 'tool'
}, {
  id: 11,
  icon: 'cell'
}, {
  id: 12,
  icon: 'basket'
}, {
  id: 13,
  icon: 'musical-note'
}, {
  id: 14,
  icon: 'heart'
}, {
  id: 15,
  icon: 'home'
}, {
  id: 16,
  icon: 'no-data'
}, {
  id: 17,
  icon: 'talk'
}, {
  id: 18,
  icon: 'skate'
}, {
  id: 19,
  icon: 'hat'
}, {
  id: 20,
  icon: 'shirt'
}, {
  id: 21,
  icon: 'controller'
}, {
  id: 22,
  icon: 'run'
}, {
  id: 23,
  icon: 'swirl'
}, {
  id: 24,
  icon: 'explosion'
}, {
  id: 25,
  icon: 'nuxiba'
}];
var CAMPAIGN_ICONS = new Proxy(CAMPAIGN_ICON_DICTIONARY, {
  get: function get(object, property) {
    return object.hasOwnProperty(property) ? object[property] : {
      id: 25,
      icon: 'nuxiba'
    };
  }
});
exports.CAMPAIGN_ICONS = CAMPAIGN_ICONS;
var CHANNEL_ICONS = {
  0: 'call',
  1: 'chat',
  4: 'ia',
  5: 'whatsapp',
  6: 'preview',
  7: 'sms'
};
exports.CHANNEL_ICONS = CHANNEL_ICONS;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/util/constants.js
// module id = 275
// module chunks = 0